const expandableLists = document.querySelectorAll('#expandable-list');
expandableLists.forEach((expandableList) => {
	const listItems = expandableList?.querySelectorAll(
		'[data-expandable-target="expandable-wrapper"]',
	);
	listItems?.forEach((item) => {
		const title = item.querySelector(
			'[data-expandable-target="expandable-title"]',
		);
		const subTitle = item.querySelector([
			'[data-expandable-target="expandable-content"]',
		]);
		subTitle.classList.add('hidden');
		const iconPath = item.querySelector('path');
		item.addEventListener('click', (ev) => {
			if (ev.target.closest('[data-expandable-target="expandable-content"]')) {
				return;
			}
			toggleExpandableList(title, subTitle, iconPath);
		});
		item.addEventListener('keydown', (ev) => {
			if (ev.key === 'Enter') {
				if (
					document.activeElement.tagName === 'A' ||
					(document.activeElement.tagName === 'BUTTON' &&
						document.activeElement.closest(
							'[data-expandable-target="expandable-content"]',
						))
				) {
					return;
				}
			}

			if (ev.key === 'Enter' || ev.key === ' ') {
				ev.preventDefault();
				toggleExpandableList(title, subTitle, iconPath);
			}
		});
	});
});

function toggleExpandableList(title, subTitle, iconPath) {
	subTitle.classList.toggle('hidden');
	title.classList.toggle('text-black');
	title.classList.toggle('text-secondary-100');
	if (subTitle.classList.contains('hidden'))
		iconPath.setAttribute(
			'd',
			'M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2',
		);
	else
		iconPath.setAttribute(
			'd',
			'M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8',
		);
}

export default {
	expandableList: expandableLists,
};
